import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadContractorCard,
  UpdateContractorCard,
} from "@/types/contractorCard";

export const ContractorPanelCardService = new APIService<
  ReadContractorCard,
  UpdateContractorCard
>(API.ContractorPanelCards);

export const fetchContractorPanelCardsList = ContractorPanelCardService.getList;
export const fetchContractorPanelCard = ContractorPanelCardService.get;
export const updateContractorPanelCard = ContractorPanelCardService.patch;
